module.exports = __webpack_public_path__ + "static/media/second-banner-bg.05fcb1fa.jpg";